//@ts-check

import AddressService from '@/angularBridgeCode/services/AddressService';



export default {

  /** @type {ringba.data.AddressRecord[]} */
  addresses: [],
  columns: AddressService.defaultColumns,
  userVisibleColumns: JSON.parse(JSON.stringify(AddressService.defaultColumns)),
  currentAccountFeatureFlags: {},
  status: {},
};